/**
 * Do not edit directly, this file was auto-generated.
 */

export default {
  color: {
    "@": {
      background: {
        page: "var(--jkl-color-background-page)",
        container: "var(--jkl-color-background-container)",
        "container-accent": "var(--jkl-color-background-container-accent)",
        contrast: "var(--jkl-color-background-contrast)",
      },
      text: {
        default: "var(--jkl-color-text-default)",
        subdued: "var(--jkl-color-text-subdued)",
        accent: "var(--jkl-color-text-accent)",
        "on-contrast": "var(--jkl-color-text-on-contrast)",
      },
      border: {
        default: "var(--jkl-color-border-default)",
        subdued: "var(--jkl-color-border-subdued)",
        strong: "var(--jkl-color-border-strong)",
      },
    },
    warning: {
      background: {
        page: "var(--jkl-color-warning-background-page)",
        container: "var(--jkl-color-warning-background-container)",
        "container-accent":
          "var(--jkl-color-warning-background-container-accent)",
        contrast: "var(--jkl-color-warning-background-contrast)",
      },
      text: {
        default: "var(--jkl-color-warning-text-default)",
        subdued: "var(--jkl-color-warning-text-subdued)",
        accent: "var(--jkl-color-warning-text-accent)",
        "on-contrast": "var(--jkl-color-warning-text-on-contrast)",
      },
      border: {
        default: "var(--jkl-color-warning-border-default)",
        subdued: "var(--jkl-color-warning-border-subdued)",
        strong: "var(--jkl-color-warning-border-strong)",
      },
    },
    success: {
      background: {
        page: "var(--jkl-color-success-background-page)",
        container: "var(--jkl-color-success-background-container)",
        "container-accent":
          "var(--jkl-color-success-background-container-accent)",
        contrast: "var(--jkl-color-success-background-contrast)",
      },
      text: {
        default: "var(--jkl-color-success-text-default)",
        subdued: "var(--jkl-color-success-text-subdued)",
        accent: "var(--jkl-color-success-text-accent)",
        "on-contrast": "var(--jkl-color-success-text-on-contrast)",
      },
      border: {
        default: "var(--jkl-color-success-border-default)",
        subdued: "var(--jkl-color-success-border-subdued)",
        strong: "var(--jkl-color-success-border-strong)",
      },
    },
    info: {
      background: {
        page: "var(--jkl-color-info-background-page)",
        container: "var(--jkl-color-info-background-container)",
        "container-accent": "var(--jkl-color-info-background-container-accent)",
        contrast: "var(--jkl-color-info-background-contrast)",
      },
      text: {
        default: "var(--jkl-color-info-text-default)",
        subdued: "var(--jkl-color-info-text-subdued)",
        accent: "var(--jkl-color-info-text-accent)",
        "on-contrast": "var(--jkl-color-info-text-on-contrast)",
      },
      border: {
        default: "var(--jkl-color-info-border-default)",
        subdued: "var(--jkl-color-info-border-subdued)",
        strong: "var(--jkl-color-info-border-strong)",
      },
    },
    error: {
      background: {
        page: "var(--jkl-color-error-background-page)",
        container: "var(--jkl-color-error-background-container)",
        "container-accent":
          "var(--jkl-color-error-background-container-accent)",
        contrast: "var(--jkl-color-error-background-contrast)",
      },
      text: {
        default: "var(--jkl-color-error-text-default)",
        subdued: "var(--jkl-color-error-text-subdued)",
        accent: "var(--jkl-color-error-text-accent)",
        "on-contrast": "var(--jkl-color-error-text-on-contrast)",
      },
      border: {
        default: "var(--jkl-color-error-border-default)",
        subdued: "var(--jkl-color-error-border-subdued)",
        strong: "var(--jkl-color-error-border-strong)",
      },
    },
  },
  unit: {
    0: "var(--jkl-unit-0)",
    10: "var(--jkl-unit-10)",
    15: "var(--jkl-unit-15)",
    20: "var(--jkl-unit-20)",
    25: "var(--jkl-unit-25)",
    30: "var(--jkl-unit-30)",
    35: "var(--jkl-unit-35)",
    40: "var(--jkl-unit-40)",
    50: "var(--jkl-unit-50)",
    60: "var(--jkl-unit-60)",
    70: "var(--jkl-unit-70)",
    80: "var(--jkl-unit-80)",
    90: "var(--jkl-unit-90)",
    100: "var(--jkl-unit-100)",
    130: "var(--jkl-unit-130)",
    210: "var(--jkl-unit-210)",
    base: "var(--jkl-unit-base)",
    "02": "var(--jkl-unit-02)",
    "05": "var(--jkl-unit-05)",
  },
  spacing: {
    0: "var(--jkl-spacing-0)",
    2: "var(--jkl-spacing-2)",
    4: "var(--jkl-spacing-4)",
    8: "var(--jkl-spacing-8)",
    12: "var(--jkl-spacing-12)",
    16: "var(--jkl-spacing-16)",
    24: "var(--jkl-spacing-24)",
    32: "var(--jkl-spacing-32)",
    40: "var(--jkl-spacing-40)",
    64: "var(--jkl-spacing-64)",
    104: "var(--jkl-spacing-104)",
    168: "var(--jkl-spacing-168)",
    none: "var(--jkl-spacing-none)",
    "2xs": "var(--jkl-spacing-2xs)",
    xs: "var(--jkl-spacing-xs)",
    s: "var(--jkl-spacing-s)",
    m: "var(--jkl-spacing-m)",
    l: "var(--jkl-spacing-l)",
    xl: "var(--jkl-spacing-xl)",
    "2xl": "var(--jkl-spacing-2xl)",
  },
  border: {
    width: {
      1: "var(--jkl-border-width-1)",
      2: "var(--jkl-border-width-2)",
      3: "var(--jkl-border-width-3)",
    },
    radius: {
      none: "var(--jkl-border-radius-none)",
      xs: "var(--jkl-border-radius-xs)",
      s: "var(--jkl-border-radius-s)",
      m: "var(--jkl-border-radius-m)",
      l: "var(--jkl-border-radius-l)",
      full: "var(--jkl-border-radius-full)",
    },
  },
  breakpoint: {
    small: "0",
    medium: "680px",
    large: "1200px",
    xl: "1600px",
  },
  motion: {
    timing: {
      energetic: "var(--jkl-motion-timing-energetic)",
      snappy: "var(--jkl-motion-timing-snappy)",
      productive: "var(--jkl-motion-timing-productive)",
      polite: "var(--jkl-motion-timing-polite)",
      expressive: "var(--jkl-motion-timing-expressive)",
      lazy: "var(--jkl-motion-timing-lazy)",
    },
    easing: {
      standard: "var(--jkl-motion-easing-standard)",
      entrance: "var(--jkl-motion-easing-entrance)",
      exit: "var(--jkl-motion-easing-exit)",
      easeInBounceOut: "var(--jkl-motion-easing-ease-in-bounce-out)",
      focus: "var(--jkl-motion-easing-focus)",
    },
  },
  font: {
    size: {
      1: "var(--jkl-font-size-1)",
      2: "var(--jkl-font-size-2)",
      3: "var(--jkl-font-size-3)",
      4: "var(--jkl-font-size-4)",
      5: "var(--jkl-font-size-5)",
      6: "var(--jkl-font-size-6)",
      7: "var(--jkl-font-size-7)",
      8: "var(--jkl-font-size-8)",
      9: "var(--jkl-font-size-9)",
      10: "var(--jkl-font-size-10)",
    },
    weight: {
      normal: "var(--jkl-font-weight-normal)",
      bold: "var(--jkl-font-weight-bold)",
    },
    family: {
      regular: "var(--jkl-font-family-regular)",
      display: "var(--jkl-font-family-display)",
      mono: "var(--jkl-font-family-mono)",
      icons: "var(--jkl-font-family-icons)",
    },
  },
  lineHeight: {
    flush: "var(--jkl-line-height-flush)",
    tight: "var(--jkl-line-height-tight)",
    relaxed: "var(--jkl-line-height-relaxed)",
  },
  textStyle: {
    title: "var(--jkl-text-style-title)",
    "title-small": "var(--jkl-text-style-title-small)",
    "heading-1": "var(--jkl-text-style-heading-1)",
    "heading-2": "var(--jkl-text-style-heading-2)",
    "heading-3": "var(--jkl-text-style-heading-3)",
    "heading-4": "var(--jkl-text-style-heading-4)",
    "heading-5": "var(--jkl-text-style-heading-5)",
    "paragraph-large": "var(--jkl-text-style-paragraph-large)",
    "paragraph-medium": "var(--jkl-text-style-paragraph-medium)",
    "paragraph-small": "var(--jkl-text-style-paragraph-small)",
    "text-large": "var(--jkl-text-style-text-large)",
    "text-medium": "var(--jkl-text-style-text-medium)",
    "text-small": "var(--jkl-text-style-text-small)",
    "text-micro": "var(--jkl-text-style-text-micro)",
  },
};
